import { SetStateAction } from 'react';
import { BrightcovePlayerRef, ChangeStyleFnPropType } from './types/propTypes';

function formatDuration(arg: number) {
  const ms = Number(String(arg).replace('.', ''));
  // Calculate total seconds from milliseconds
  const totalSeconds = Math.floor(ms / 1000);

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format the time in HH:MM:SS or MM:SS depending on hours
  const hoursPart = hours > 0 ? `${hours}:` : ''; // Only include hours if greater than 0
  const minutesPart = `${minutes.toString().padStart(2, '0')}`;
  const secondsPart = `${seconds.toString().padStart(2, '0')}`;

  // Return the formatted time
  return `${hoursPart}${minutesPart}:${secondsPart}`;
}
const changeButtonStyle = ({ element, buttonSize, margin, fontSize }: ChangeStyleFnPropType) => {
  const childSpan = element.children['0'] as HTMLSpanElement;
  element.style.height = element.style.width = element.style.lineHeight = buttonSize;
  element.style.marginTop = element.style.marginLeft = margin;
  // child span element
  childSpan.style.fontSize = fontSize;
};
function handleOnSuccess(
  success: { ref: BrightcovePlayerRef },
  showDuration: boolean,
  setDuration: React.Dispatch<SetStateAction<string>>,
  processStyle: (ref?: HTMLButtonElement) => void,
  playerRef?: React.MutableRefObject<BrightcovePlayerRef>,
  playerOnReadyHandler?: (playerRef: React.MutableRefObject<BrightcovePlayerRef>) => void,
) {
  const player = success.ref;
  if (showDuration) {
    player.on('loadedmetadata', function () {
      const variable = success.ref.mediainfo.duration;
      const currentDuration = formatDuration(variable || 0);
      setDuration(currentDuration);
    });
  }
  if (playerRef) {
    playerRef.current = player;
  }
  player.ready?.(function () {
    processStyle(player?.bigPlayButton?.el_);
    playerRef && playerOnReadyHandler?.(playerRef);
  });
}
export { formatDuration, changeButtonStyle, handleOnSuccess };
